import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=644126fc&scoped=true"
import script from "./Messages.vue?vue&type=script&setup=true&lang=js"
export * from "./Messages.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Messages.vue?vue&type=style&index=0&id=644126fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644126fc",
  null
  
)

export default component.exports